import * as tslib_1 from "tslib";
import { CHANNEL } from '../../../../constants/channel.constants';
import { BaseChannelCommunicatorService } from '../base-channel-communicator.service';
import { LoadingService } from '../../../loading/loading.service';
var SuperappImplService = /** @class */ (function (_super) {
    tslib_1.__extends(SuperappImplService, _super);
    /**
     * Constructor de la clase
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los modelos
     *
     * *Initialize method for models*
     *
     * @function initService
     */
    function SuperappImplService(loading) {
        var _this = _super.call(this) || this;
        _this.loading = loading;
        _this.CHANNEL_ID = CHANNEL.SUPERAPP.CODE;
        _this.initService();
        return _this;
    }
    /**
     * Creación de la promesa para la comunicación con portalpn
     *
     * *Promise creation for portalpn communication*
     *
     * @param {string} op
     */
    SuperappImplService.prototype.createPromise = function (op) {
        return new Promise(function (resolve, _reject) {
            var data;
            var callback = function (event) {
                try {
                    data = JSON.parse(event.data);
                }
                catch (error) {
                    return;
                }
                if (data.origin !== CHANNEL.SUPERAPP.NAME || data.op !== op) {
                    return;
                }
                resolve(data);
                window.removeEventListener('message', callback);
                document.removeEventListener('message', callback);
            };
            window.addEventListener('message', callback);
            document.addEventListener('message', callback);
        });
    };
    /**
     * Llamada a una función Nativa dependiendo del canal
     *
     * *Calls native function depending on the channel*
     *
     * @param {ExternalRequest} request
     */
    SuperappImplService.prototype.postMessageToChannel = function (request) {
        var _this = this;
        var getExternalContext = function () {
            return new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var maxTime, gradient, i;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            maxTime = 5000;
                            gradient = 100;
                            i = gradient;
                            _a.label = 1;
                        case 1:
                            if (!(i < maxTime)) return [3 /*break*/, 4];
                            if (window['ReactNativeWebView']) {
                                resolve(window['ReactNativeWebView']);
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, new Promise(function (innerResolve) {
                                    setTimeout(innerResolve, gradient);
                                })];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            i += gradient;
                            return [3 /*break*/, 1];
                        case 4:
                            reject('Fatal. External context not found.');
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        window.parent.postMessage(JSON.stringify(request), '*');
        getExternalContext().then(function (context) {
            context.postMessage(JSON.stringify(request));
        }, function (err) {
            console.error(err + ' Application unavailable.');
        });
    };
    return SuperappImplService;
}(BaseChannelCommunicatorService));
export { SuperappImplService };
